import { Button, Checkbox, Input } from '@calizahq/react-components-v2'
import { AgentMutations } from '@sales-app/graphql/mutations/agent.mutations'
import { AgentQueries } from '@sales-app/graphql/queries/agent.queries'
import { Form, Formik } from 'formik'
import { debounce } from 'lodash'
import { FC, useState } from 'react'

import { InputSelect } from '@/components'
import { UserQueries } from '@/graphql/queries/user.queries'
import { graphQLClient, useGraphqlMutation } from '@/hooks/useGraphql'

import { CereateAgentFormValuesType, initialValues } from './CreateAgent.util'

type CreateAgentFormProps = {
  refetchOnSuccess: () => void
  toggle: () => void
}

export const CreateAgentForm: FC<CreateAgentFormProps> = ({ refetchOnSuccess, toggle }) => {
  const [error, setError] = useState<string>()

  const { mutate, isPending: isInsertLoading } = useGraphqlMutation(AgentMutations.createAgent(), {
    onSuccess: () => {
      refetchOnSuccess && refetchOnSuccess()
      toggle && toggle()
    },
    onError: () => {
      setError('Error creating new agent')
    },
  })
  const debouncedSearchUser = debounce(searchOwner, 1000, { leading: true })
  const loadUserOptions = (inputValue) => debouncedSearchUser(inputValue)

  const debouncedSearchAgent = debounce(searchAgent, 1000, { leading: true })
  const loadAgentOptions = (inputValue) => debouncedSearchAgent(inputValue)

  const roleOptions = [
    { label: 'Agent', value: 'Agent' },
    { label: 'Supervisor', value: 'Supervisor' },
  ]

  const handleInsert = (values: CereateAgentFormValuesType) => {
    mutate({
      agent: {
        ...values,
      },
    })
  }

  return (
    <Formik enableReinitialize={true} initialValues={{ ...initialValues }} onSubmit={handleInsert}>
      {() => {
        return (
          <Form className="flex w-full flex-col flex-wrap px-6 md:max-w-120">
            <p className="mb-4 mt-4 font-bold text-header-md leading-none">New Agent</p>
            <InputSelect
              async={true}
              className="mb-4 w-full"
              defaultOptions={false}
              id="adminUserId"
              label="User"
              loadOptions={loadUserOptions}
              name="adminUserId"
              nullLabel="---"
              overviewDropdown={true}
            />
            <InputSelect
              async={true}
              className="mb-4 w-full"
              defaultOptions={false}
              id="managerUserId"
              label="Supervisor"
              loadOptions={loadAgentOptions}
              name="managerUserId"
              nullLabel="---"
              overviewDropdown={true}
            />
            <InputSelect className="mb-4 w-full" id="role" label="Role" name="role" options={roleOptions} />
            <Input className="w-full mb-4" id="dialpadUserId" label="Dialpad User ID" name="dialpadUserId" />
            <Checkbox className="w-full mb-4" id="standard" label="Standard" name="standard" />
            <Checkbox className="w-full mb-4" id="corporateHousing" label="Corporate Housing" name="corporateHousing" />
            <div>{error && <p className=" mb-4 text-p-sm text-text-semantic-error">{error}</p>}</div>
            <div className="mt-4 flex justify-end md:flex-row	">
              <Button
                className="mb-2 w-full bg-text-semantic-success md:mb-0 md:w-auto"
                disabled={isInsertLoading}
                isLoading={isInsertLoading}
                size="small"
                type="submit"
              >
                Create Agent
              </Button>
            </div>
          </Form>
        )
      }}
    </Formik>
  )
}

const searchAgent = (inputValue: string) => {
  return graphQLClient
    .request(AgentQueries.getSearchSupervisor(), {
      searchString: inputValue,
    })
    .then((resResponse: AgentQueries.GET_SEARCH_SUPERVISOR.Response) => {
      if (resResponse.agents) {
        return resResponse.agents.map((agent) => ({ label: agent?.name || '', value: agent?.userId }))
      } else {
        return []
      }
    })
}

const searchOwner = (inputValue: string) => {
  return graphQLClient
    .request<any>(UserQueries.getSearchInternalUser(), {
      searchString: inputValue,
    })
    .then((resRespons) => {
      return resRespons.authorizedUsers.map((authorizedUser) => ({
        label: authorizedUser?.fullName || '',
        value: authorizedUser?.id,
      }))
    })
}
